import { TextField, MenuItem, IconButton } from '@material-ui/core';
import React, { useEffect, useState } from 'react';

import { DragDropContext, Draggable, Droppable } from '@react-forked/dnd';
import { cloneDeep } from 'lodash';
import BookmarkBorderSharpIcon from '@material-ui/icons/BookmarkBorderSharp';
import BookmarkSharpIcon from '@material-ui/icons/BookmarkSharp';

import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { panelSettingAtom } from '@/state/atom/panelAtom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { isUseItemInTicket, isEditField } from '../handler/CommonHandler';
import { I18n } from 'aws-amplify';

import {
    getFormMasterList,
    getTicketMasterKnowledgeList
} from '@/component/formManagement/addField/handler/MasterKnowledgeHandler';
import OverFlowTooltip from '@/component/common/OverFlowTooltip';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { formListOfProjectSelector } from '@/state/selector/formSelector';
import { isHiddenEditBtn } from './handler/AddFieldTagItemHandler';
import { userAtom } from '@/state/atom/userAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';

export default function MasterKnowledge(props) {
    const [formMasterList, setFormMasterList] = useState([]);
    const [formMasterIdSelected, setFormMasterIdSelected] = useState(
        props.masterKnowledge.formMaster
    );
    const [ticketKnowledgeMasterList, setTicketKnowledgeMasterList] = useState([]);
    const [itemActiveList, setItemActiveList] = useState([]);
    const [itemInActiveList, setItemInActiveList] = useState([]);
    const [settingSlideRecoilState, setSettingSlideRecoilState] = useRecoilState(panelSettingAtom);
    const [useButtonCollapse, setUseButtonCollapse] = useState(true);
    const [currentUpdateField] = useState(props.currentUpdateField);
    const [unUseButtonCollapse, setUnUseButtonCollapse] = useState(true);
    const [listFormOfProject, setListFormOfProject] = useRecoilState(formListOfProjectSelector);
    const [listHiddenActiveItem,setListHiddenActiveItem] = useState([])
    const [listHiddenInactiveItem,setListHiddenInactiveItem] = useState([])

        // common userDetail state
        const userDetail = useRecoilValue(userAtom);
        const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
        const corporationDetail = useRecoilValue(corporationAtom);

    const argsCommon = {
        ...props,

        formMasterList,
        setFormMasterList,

        formMasterIdSelected,
        setFormMasterIdSelected,

        ticketKnowledgeMasterList,
        setTicketKnowledgeMasterList,

        itemActiveList,
        setItemActiveList,

        itemInActiveList,
        setItemInActiveList,

        settingSlideRecoilState,
        setSettingSlideRecoilState,
        listFormOfProject,
        userDetail: userDetail,
        projectInuseDetail: projectInuseDetail,
        corporationDetail: corporationDetail
    };

    // init data form master list
    useEffect(() => {
        // get form master list
        getFormMasterList(argsCommon);
    }, []);

    // get knowledge ticket list
    useEffect(() => {
        getTicketMasterKnowledgeList(argsCommon);
    }, [formMasterIdSelected, formMasterList]);

    // update activeItemList
    useEffect(() => {
        let itemData = {
            itemActiveList: itemActiveList,
            itemInActiveList: itemInActiveList
        };
        updateMasterKnowledge('active_list', itemData);
    }, [itemActiveList, itemInActiveList]);

    // update active item list/inactive item list
    useEffect(() => {
        if (currentUpdateField.relatedMasterForm !== formMasterIdSelected) {
            let listDisplayActiveItemClone = [];
            let listHiddenActiveItemClone = [];
            ticketKnowledgeMasterList?.forEach(ticket => {
                if(ticket.userHasViewPermission){
                    listDisplayActiveItemClone.push(ticket)
                }else{
                    listHiddenActiveItemClone.push(ticket)
                }
            });
            setItemActiveList(listDisplayActiveItemClone);
            setListHiddenActiveItem(listHiddenActiveItemClone)
            setItemInActiveList([]);
        } else {
            let activeList = [];
            let inActiveList = [];
            let listHiddenActiveItemClone = [];
            let listHiddenInactiveItemClone = [];
            currentUpdateField.structure.listItem.forEach(item => {
                let index = Utils.findIndexInArrayById(item.itemId, ticketKnowledgeMasterList);
                if (index !== -1) {
                    if (item.isActive) {
                        if(ticketKnowledgeMasterList[index]?.userHasViewPermission){
                            activeList.push(ticketKnowledgeMasterList[index]);
                        }else{
                            listHiddenActiveItemClone.push(ticketKnowledgeMasterList[index])
                        }
                    } else {
                        if (ticketKnowledgeMasterList[index]?.userHasViewPermission) {
                            inActiveList.push(ticketKnowledgeMasterList[index]);
                        } else {
                            listHiddenInactiveItemClone.push(ticketKnowledgeMasterList[index]);
                        }
                    }
                }
            });
            setListHiddenActiveItem(listHiddenActiveItemClone);
            setListHiddenInactiveItem(listHiddenInactiveItemClone)
            console.log('activeList :>>++++++++++++ ', activeList);
            setItemActiveList(activeList);
            setItemInActiveList(inActiveList);
        }
    }, [ticketKnowledgeMasterList]);

    // update master knowledge
    const updateMasterKnowledge = (type, data) => {
        let masterKnowledgeClone = cloneDeep(props.masterKnowledge);
        switch (type) {
            case 'form_master':
                masterKnowledgeClone.formMaster = data;
                masterKnowledgeClone.errorFormMasterSelected = '';
                break;
            case 'auto_add_data':
                masterKnowledgeClone.isAutoAddData = !masterKnowledgeClone.isAutoAddData;
                break;
            case 'active_list':
                let listItem = [];
                // active list
                data.itemActiveList.forEach((item, index) => {
                    let currentItem = props.masterKnowledge?.listItem?.find(
                        o => o.itemId === item.id
                    );
                    let hitNumber = Utils.isEmpty(currentItem) ? 0 : currentItem.hitNumber;
                    listItem.push({
                        itemId: item.id,
                        isActive: true,
                        hitNumber: hitNumber,
                        order: index,
                        listTicketId: []
                    });
                });

                // inActive list
                data.itemInActiveList.forEach((item, index) => {
                    let currentItem = props.masterKnowledge?.listItem?.find(
                        o => o.itemId === item.id
                    );
                    let hitNumber = Utils.isEmpty(currentItem) ? 0 : currentItem.hitNumber;
                    listItem.push({
                        itemId: item.id,
                        isActive: false,
                        hitNumber: hitNumber,
                        order: index,
                        listTicketId: []
                    });
                });
                listHiddenInactiveItem?.forEach((item,index) => {
                    let currentItem = props.masterKnowledge?.listItem?.find(
                        o => o.itemId === item.id
                    );
                    let hitNumber = Utils.isEmpty(currentItem) ? 0 : currentItem.hitNumber;
                    listItem.push({
                        itemId: item.id,
                        isActive: false,
                        hitNumber: hitNumber,
                        listTicketId: []
                    });
                });

                listHiddenActiveItem?.forEach((item,index) => {
                    let currentItem = props.masterKnowledge?.listItem?.find(
                        o => o.itemId === item.id
                    );
                    let hitNumber = Utils.isEmpty(currentItem) ? 0 : currentItem.hitNumber;
                    listItem.push({
                        itemId: item.id,
                        isActive: true,
                        hitNumber: hitNumber,
                        listTicketId: []
                    });
                })
                masterKnowledgeClone.listItem = listItem;
                break;
            default:
                break;
        }
        props.setMasterKnowledge(masterKnowledgeClone);
    };

    // handler onChange form master
    const onChangeFormMaster = event => {
        let formId = event.target.value;
        setFormMasterIdSelected(formId);

        updateMasterKnowledge('form_master', formId);
        props.setIsDisableBtnSave(false)
    };

    /** handler onDragEnd */
    const onDragEnd = result => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        let startIndex = result.source.index;
        let endIndex = result.destination.index;

        let itemActiveListClone = cloneDeep(itemActiveList);
        let [removed] = itemActiveListClone.splice(startIndex, 1);
        itemActiveListClone.splice(endIndex, 0, removed);

        //enable slide and set current start index
        let newSetting;
        newSetting = { ...settingSlideRecoilState };
        newSetting.disable = false;
        setSettingSlideRecoilState(newSetting);

        // update item active list
        let itemData = {
            itemActiveList: itemActiveListClone,
            itemInActiveList: itemInActiveList
        };
        updateMasterKnowledge('active_list', itemData);

        setItemActiveList(itemActiveListClone);
    };

    
    const hanldeUseButtonCollapse = () => {
        if (useButtonCollapse === true) {
            setUseButtonCollapse(false);
        } else {
            setUseButtonCollapse(true);
        }
    };

    const hanldeUnUseButtonCollapse = () => {
        if (unUseButtonCollapse === true) {
            setUnUseButtonCollapse(false);
        } else {
            setUnUseButtonCollapse(true);
        }
    };

    /** handler onBeforeDragStartHandler  */
    const onBeforeDragStartHandler = event => {
        //disable slide before drag start
        let newSetting = { ...settingSlideRecoilState };
        newSetting.disable = true;

        setSettingSlideRecoilState(newSetting);
    };

    /** handler onChangeUsingItem */
    const onChangeUsingItem = (event, field, isUsingItem) => {
        if (!isEditField(props.currentUpdateField, props)) {
            return;
        }

        let itemActiveListClone = cloneDeep(itemActiveList);
        let itemInActiveListClone = cloneDeep(itemInActiveList);

        if (!isUsingItem) {
            itemInActiveListClone.push(field);
            itemActiveListClone = Utils.removeItemInArrayById(field.id, itemActiveListClone);
        } else {
            itemActiveListClone.push(field);
            itemInActiveListClone = Utils.removeItemInArrayById(field.id, itemInActiveListClone);
        }

        setItemActiveList(itemActiveListClone);
        setItemInActiveList(itemInActiveListClone);

        let itemData = {
            itemActiveList: itemActiveListClone,
            itemInActiveList: itemInActiveListClone
        };

        // update item active list
        updateMasterKnowledge('active_list', itemData);
        props.setIsDisableBtnSave(false);
    };

    const renderItem = (item, index) => {
        return (
            <>
                <div className="lst-number">{index+1}.</div>
                <div className="lst-text">
                <div style={{maxWidth: '98%'}} ><OverFlowTooltipWithTabsMui value={`${item.name}`}></OverFlowTooltipWithTabsMui></div>
                    <div className="item-formTag" style={{paddingRight: '5px'}}>
                        {!isHiddenEditBtn(props) && (
                            <>
                                <IconButton
                                    className="itemTools"
                                    onClick={event => onChangeUsingItem(event, item, false)}
                                >
                                    <img src="/assets/image/icon-pin.svg" alt="" />
                                </IconButton>
                            </>
                        )}
                    </div>
                </div>
            </>
        );
    };
   
    /** render item active list */
    const renderItemActiveList = () => {
        return (
            <DragDropContext onDragEnd={onDragEnd} onBeforeDragStart={onBeforeDragStartHandler}>
                <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                        <ul
                            data-cy="tag-items-active-list"
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            // style={getListStyle(snapshot.isDraggingOver)}
                        >
                            {itemActiveList.map((item, index) => (
                                <Draggable
                                    // isDragDisabled={true}
                                    key={item.id}
                                    draggableId={`${item.id}`}
                                    index={index}
                                    isDragDisabled={
                                        props.displayOrder ===
                                        Constant.DISPLAY_ORDER_TAG_FIELD.HITS_NUMBER_ORDER
                                    }
                                >
                                    {(provided, snapshot) => (
                                        <li
                                            className={!isUseItemInTicket(item, props.currentUpdateField) ? "listField-li background-color-usingForm" : "listField-li"}
                                            id={item.id}
                                            key={item.id}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            // style={getItemStyle(
                                            //     snapshot.isDragging,
                                            //     provided.draggableProps.style
                                            // )}
                                        >
                                            {renderItem(item, index, true)}
                                        </li>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </ul>
                    )}
                </Droppable>
            </DragDropContext>
        );
    };

    /** render item inactive list */
    const renderItemInActiveList = () => {
        return (
            <ul>
                {itemInActiveList.map((item, index) => {
                    return (
                        <li  className={!isUseItemInTicket(item, props.currentUpdateField) ? "listField-li background-color-usingForm" : "listField-li"}>
                            <>
                                <div className="lst-number">{index + 1}.</div>
                                <div className="lst-text">
                                 <div style={{maxWidth: '98%'}} ><OverFlowTooltip value={item.name}></OverFlowTooltip></div>
                                    <div className="item-formTag" style={{paddingRight: '5px'}}>
                                        {!isHiddenEditBtn(props) && (
                                            <>
                                                <IconButton
                                                    className="itemTools"
                                                    onClick={event =>
                                                        onChangeUsingItem(event, item, true)
                                                    }
                                                >
                                                    <img
                                                        src="/assets/image/icon-pin-outline.svg"
                                                        alt=""
                                                    />
                                                </IconButton>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </>
                        </li>
                    );
                })}
            </ul>
        );
    };

    return (
        <>
            {/* form list */}
             <div className="createCustomize">
                <ul>
                    <li className="w-100">
                        <label className="createCustomize-label">
                            使用するマスター
                        </label>
                        <div className="createCustomize-control">
                            <TextField
                                className={
                                    !Utils.isEmptyString(
                                        props.masterKnowledge.errorFormMasterSelected
                                    )
                                        ? 'form-control--wrap form-control--hg32 selectbox-err'
                                        : 'form-control--wrap form-control--hg32 selectbox-search'
                                }
                                value={formMasterIdSelected}
                                select
                                variant="outlined"
                                SelectProps={{
                                    MenuProps: {
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left'
                                        },
                                        getContentAnchorEl: null,
                                        className: 'selectDrop'
                                    }
                                }}
                                onChange={event => {
                                    onChangeFormMaster(event);
                                }}
                                disabled={!isEditField(props.currentUpdateField, props)}
                                error={props.masterKnowledge.errorFormMasterSelected}
                            >
                                {formMasterList.map((item, key) => {
                                    return (
                                        <MenuItem key={item.id} value={item.id}>
                                            {Utils.getTextByLanguage(
                                                Constant.LANGUAGE_TYPE.JP,
                                                item.name
                                            )}
                                        </MenuItem>
                                    );
                                })}
                            </TextField>

                            {!Utils.isEmptyString(props.masterKnowledge.errorFormMasterSelected) &&
                                (
                                    <>
                                        {' '}
                                        <br />
                                        <span className="message-error">
                                            {I18n.get(
                                                `${props.masterKnowledge.errorFormMasterSelected}`
                                            )}
                                        </span>
                                    </>
                                )}
                        </div>
                    </li>
                </ul>
            </div>

            {/* auto add data*/}
            <div className="createSwitch">
                <p className="createSwitch-text">新しいマスターナレッジを選択項目に自動追加する</p>
                <div className="switch-check">
                    <input
                        type="checkbox"
                        id={`switch-show-all-chat-post-auto_add_data_with_outline_ticket`}
                        defaultChecked={props.masterKnowledge.isAutoAddData}
                        onChange={event => {
                            updateMasterKnowledge('auto_add_data');
                        }}
                        disabled={!isEditField(props.currentUpdateField, props)}
                    />
                    <label
                        for={`switch-show-all-chat-post-auto_add_data_with_outline_ticket`}
                    ></label>
                </div>
            </div>

            <ul className="listForm-ul master-knowledge-listItem">
                {!Utils.isEmptyString(props.masterKnowledge.formMaster) &&
                    Utils.isEmptyArray(itemActiveList) &&
                    Utils.isEmptyArray(itemInActiveList) && (
                        <div className="master-knowledge-item-empty">{I18n.get('COMMSG034')}</div>
                    )}

                {(!Utils.isEmptyArray(itemActiveList) || !Utils.isEmptyArray(itemInActiveList)) && (
                    <>
                    <div
                    className={
                        !useButtonCollapse
                            ? 'accordionForm accordionForm--show'
                            : 'accordionForm'
                    }
                >
                    {/* Khi click vào 'div accordionHead' thì 'div accordionForm sẽ add accordionForm--show' */}
                    <div className="accordionHead" onClick={hanldeUseButtonCollapse}>
                        <span className="accordionHead-item">
                            <img src="/assets/image/icon-pin.svg" alt="" />
                        </span>
                        <span className="accordionHead-text">
                            以下の選択項目は使用する ({itemActiveList.length})
                        </span>
                    </div>
                    <div className="accordionContent">
                        <div className="lst-formTag">
                        {renderItemActiveList()}

                        </div>
                        {/* lst-formTag */}
                    </div>
                </div>
                {/* accordionForm */}
                <div
                    className={
                        !unUseButtonCollapse
                            ? 'accordionForm accordionForm--show'
                            : 'accordionForm'
                    }
                >
                    {/* Khi click vào 'div accordionHead' thì 'div accordionForm sẽ add accordionForm--show' */}
                    <div className="accordionHead" onClick={hanldeUnUseButtonCollapse}>
                        <span className="accordionHead-item">
                            <img src="/assets/image/icon-pin-outline.svg" alt="" />
                        </span>
                        <span className="accordionHead-text">
                            以下の選択項目は使用しない ({itemInActiveList.length})
                        </span>
                    </div>
                    <div className="accordionContent">
                        <div className="lst-formTag">
                        {renderItemInActiveList()}
                        </div>
                        {/* lst-formTag */}
                    </div>
                </div>
                      
                    </>
                )}
            </ul>
        </>
    );
}
